// export default function ConnectButton() {
//     return <w3m-button />
// }
import React, { useState, useEffect } from 'react';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useAccount } from 'wagmi'; // Assuming you're using wagmi for account management

const ConnectButton = () => {
    const { open, close } = useWeb3Modal();
    const { isConnected, address } = useAccount();
    const [connectedAddress, setConnectedAddress] = useState('');

    // Update the connected address when the account changes
    useEffect(() => {
        if (isConnected && address) {
            setConnectedAddress(address);
        } else {
            setConnectedAddress('');
        }
    }, [isConnected, address]);

    return (
        <button
            onClick={() => open()}
            className='bg-secondary flex items-center px-4 py-3 gap-2 text-black rounded-2xl'
        >
            <img className='w-[30px]' src='../../assets/Vector.png' alt='Connect Wallet' />
            {connectedAddress ? (
                <span>{`${connectedAddress.slice(0, 6)}...${connectedAddress.slice(-4)}`}</span>
            ) : (
                'Connect Wallet'
            )}
        </button>
    );
};

export default ConnectButton;


